var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cta',{attrs:{"data":Object.assign({}, {icon: 'arrow',
    iconRotation: 90,
    title: _vm.$labels.download_cta},
      _vm.data)}})}
var staticRenderFns = []

export { render, staticRenderFns }